import { render } from "./Checkmark.vue?vue&type=template&id=5c585435"
const script = {}
script.render = render

export default script